import { Components, Theme } from '@mui/joy';

export const JoyTextAreaConfig: Partial<Components<Theme>> = {
  JoyTextarea: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        return {
          ...(!ownerState.error && {
            borderColor: theme.palette.neutral[300],
          }),
          backgroundColor: theme.palette.common.white,
          boxShadow: 'none',
          borderRadius: '4px',
          minHeight: '40px',
          color: theme.palette.neutral.outlinedColor,
          '&:hover': {
            borderColor: ownerState.error ? theme.palette.danger[500] : theme.palette.primary[500],
          },
        };
      },
    },
    defaultProps: {
      maxRows: 8,
    },
  },
};
